"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getTopCookieDomain() {
    var hostname = window.location.hostname;
    var hostsplit = hostname.split('.');
    if (hostsplit.length > 2) {
        return ".".concat(hostsplit.slice(-2).join('.'));
    }
    return hostname;
}
exports.default = getTopCookieDomain;
//# sourceMappingURL=getTopDomain.js.map